
import React from "react";
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const data = [
  { year: "Year 0 (Dec-25)", revenue: 12.2, arr: 10.4, ebitda: 5.4 },
  { year: "Year 1 (Dec-26)", revenue: 23.5, arr: 18.9, ebitda: 8.9 },
  { year: "Year 2 (Dec-27)", revenue: 34.6, arr: 27.3, ebitda: 12.9 },
  { year: "Year 3 (Dec-28)", revenue: 49.3, arr: 38.2, ebitda: 18.4 },
  { year: "Year 4 (Dec-29)", revenue: 70.1, arr: 53.4, ebitda: 26.2 },
  { year: "Year 5 (Dec-30)", revenue: 99.3, arr: 74.8, ebitda: 37.3 },
  { year: "Year 6 (Dec-31)", revenue: 140.6, arr: 104.7, ebitda: 52.5 },
  { year: "Year 7 (Dec-32)", revenue: 198.6, arr: 146.6, ebitda: 73.9 },
  { year: "Year 8 (Dec-33)", revenue: 280.2, arr: 205.2, ebitda: 104.0 },
  { year: "Year 9 (Dec-34)", revenue: 394.9, arr: 287.3, ebitda: 146.1 },
  { year: "Year 10 (Dec-35)", revenue: 556.0, arr: 402.3, ebitda: 205.3 }
];

const ReturnsChart: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white border border-gray-100 rounded-lg p-5 shadow-sm">
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Financial Projections (US$ M)</h3>
          <p className="text-sm text-gray-600">10-year projections showing platform scale and cash flow generation</p>
        </div>
        
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="year" 
                tick={{ fontSize: 10 }}
                interval={1}
                angle={-45}
                textAnchor="end"
                height={80}
              />
              <YAxis />
              <Tooltip formatter={(value) => [`$${value}M`, ""]} />
              <Legend />
              <Bar dataKey="revenue" name="Revenue" fill="#94c0e4" />
              <Bar dataKey="ebitda" name="EBITDA" fill="#4f86c6" />
              <Line dataKey="arr" name="ARR" stroke="#0a3a75" strokeWidth={2} type="monotone" />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default ReturnsChart;
